import data from './data.json';

const getApiData = () => {
  return data;
};

export default getApiData;